import './Trip.css'


import React from 'react'

const TripData = () => {
  return (
    <>
    <div className='trip-data'>
        <div className='t-image'>
          <img src="https://images.unsplash.com/photo-1588893968277-50b9e91ba970?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGVpZmZlbCUyMHRvd2VyJTIwYXQlMjBuaWdodHxlbnwwfDB8MHx8&auto=format&fit=crop&w=500&q=60" alt='pic'/>
        </div>
        <h3 className='orangeText' > Paris Night </h3>
        <p>I could stare at the Eiffel Tower all day long.Paris is not just the capital of France; it’s the capital of fashion and the city of love. Located by the River Seine in the north of France, Paris is reputed for being the most beautiful and romantic city in the world. It is overwhelmed with culture, history, iconic architecture, arty treasures, delicious food and exciting fashion. Europe’s most enchanting city, Paris is known for its many monuments, especially the Eiffel Tower, Notre-Dame Cathedral, Arc de Triomphe, Opéra Garnier, Les Invalides, etc

        </p>
    </div>
    <div className='trip-data'>
        <div className='t-image'>
          <img src="https://images.unsplash.com/photo-1600520611035-84157ad4084d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGVneXB0fGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt='pic'/>
        </div>
        <h3 className='orangeText'> Egypt a Mystery </h3>
        <p>Ancient Egypt -- a land of mysteries. No other civilization has so captured the imagination of scholars and laypeople alike. Mystery surrounds its origins, its religion and its monumental architecture: colossal temples, pyramids and the enormous Sphinx. The Egyptian pyramids are the most famous of all the ancient monuments, the only remaining wonder of the seven wonders of the ancient world.Egyptian hieroglyphs were the first written language</p>
    </div>
    <div className='trip-data'>
        <div className='t-image'>
          <img src="https://images.unsplash.com/photo-1573398643956-2b9e6ade3456?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDF8fGluZGlhfGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt='pic'/>
        </div>
        <h3 className='orangeText'> Incredible India </h3>
        <p>One of the oldest civilisations in the world, India is a mosaic of multicultural experiences. With a rich heritage and myriad attractions, the country is among the most popular tourist destinations in the world. It covers an area of 32, 87,263 sq. km, extending from the snow-covered Himalayan heights to the tropical rain forests of the south. As the 7th largest country in the world, India stands apart from the rest of Asia, marked off as it is by mountains and the sea, which give the country a distinct geographical entity.</p>
    </div>
    </>
  )
}

export default TripData